export default "__VITE_ASSET__DmWfFWXH__"